/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./AppBreadcrumbs.vue?vue&type=template&id=f8b435de"
import script from "./AppBreadcrumbs.ts?vue&type=script&lang=ts&external"
export * from "./AppBreadcrumbs.ts?vue&type=script&lang=ts&external"
import style0 from "./AppBreadcrumbs.vue?vue&type=style&index=0&id=f8b435de&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports